import { render } from "./TradingCandleOptions.vue?vue&type=template&id=2bbfbefe&scoped=true"
import script from "./TradingCandleOptions.vue?vue&type=script&lang=js"
export * from "./TradingCandleOptions.vue?vue&type=script&lang=js"

import "./TradingCandleOptions.vue?vue&type=style&index=0&id=2bbfbefe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bbfbefe"]])

export default __exports__